module.exports = __webpack_public_path__ + "static/logo-min-371b3353f2e80d0c53b458dbbb7fd98f.png";